import { getAttendeesCountByRaceByGroup } from '@prisma/client/sql'
import { match } from 'ts-pattern'
import { GroupRaceInventory } from 'domain/models/Group/CreateGroup'
import { Group } from 'domain/models/Group/EntityGroup'
import { GroupSelectType } from './GroupSelect'

export const getGroupRegistrationStatus = (
  {
    registrationOpeningDate,
    registrationClosingDate
  }: Pick<
    GroupSelectType,
    'registrationOpeningDate' | 'registrationClosingDate'
  >,
  currentDate = new Date()
) => {
  if (registrationOpeningDate && currentDate < registrationOpeningDate) {
    return 'early'
  }
  if (registrationClosingDate && currentDate > registrationClosingDate) {
    return 'closed'
  }
  return 'open'
}

export const convertPrismaGroupToLiveGroup = (
  {
    id: groupId,
    slug,
    isActive,
    registrationOpeningDate,
    registrationClosingDate,
    name,
    editionId,
    userGroups,
    races
  }: GroupSelectType,
  groupRaceInventories: GroupRaceInventory[],
  attendeesCountByRaceByGroup?: getAttendeesCountByRaceByGroup.Result[]
): Group => {
  const userGroup = userGroups[0]

  if (!userGroup) {
    throw new Error('Group must have a user groupContact')
  }
  if (!userGroup.user.email) {
    throw new Error('User groupContact must have an email')
  }

  return {
    id: groupId,
    isActive,
    slug,
    name,
    editionId,
    registrationOpeningDate,
    registrationClosingDate,
    groupRegistrationStatus: getGroupRegistrationStatus({
      registrationOpeningDate,
      registrationClosingDate
    }),
    userGroupContact: {
      email: userGroup.user.email,
      firstName: userGroup.user.firstName,
      id: userGroup.user.id,
      lastName: userGroup.user.lastName
    },
    races: races.map(({ race: { id, name } }) => {
      const attendees = attendeesCountByRaceByGroup?.find(
        (count) => count.groupId === groupId && count.raceId === id
      )
      const registrationsCount = match(attendees)
        .with({ priceType: 'PER_PERSON' }, (a) => Number(a.attendeeCount))
        .with({ priceType: 'PER_TEAM' }, (a) =>
          Number(a.teamRegistrationsCount)
        )
        .otherwise(() => 0)

      const groupRaceInventory = groupRaceInventories.find(
        (inventory) => inventory.raceId === id && inventory.groupId === groupId
      )

      return {
        id,
        name,
        registrationsCount,
        priceType: attendees?.priceType,
        inventory:
          groupRaceInventory?.stockedQuantity && groupRaceInventory?.variantId
            ? {
                variantId: groupRaceInventory?.variantId,
                reserved: groupRaceInventory.reservedQuantity ?? 0,
                stockedQuantity: groupRaceInventory.stockedQuantity ?? 0
              }
            : null
      }
    })
  }
}
